import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import SuccessPage from './SuccessPage';

import SecuritiesSpvLlc from './01securitiesSPV_LLC'; 
import RealEstateSpvLlc from './02realEstateSPV_LLC';
import SecuritiesSpvLp from './03securitiesSPV_LP';
import RealEstateSpvLp from './04realEstateSPV_LP';
import SecuritiesFundLp from './05securitiesFund_LP';
import RealEstateFundLp from './06realEstateFund_LP';

import AppendixA from './AppendixA';
import ContactForm from "./contact";
import TaxForms from "./taxLinks"; 

import './style/App.css';
import Login from './login';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <Router>
      <div className="App">
      <header className="header flex items-center justify-between px-4 py-0 h-10">
      <div className="logo">
        <img src="/logo.png" alt="Logo" />
        TIL Subscribe
      </div>

  <button className="menu-button" onClick={toggleMenu}>Menu</button>

  <nav className={`nav-links ${menuOpen ? "show" : "hide"}`}>
    <ul>
      <li><Link to="/" onClick={toggleMenu}>XEIA Subscription Form</Link></li>
      <li><Link to="/AppendixA" onClick={toggleMenu}>Appendix A</Link></li>
      <li><Link to="/TaxForms" onClick={toggleMenu}>Tax Forms</Link></li>
    </ul>
  </nav>
</header>


        
        <div className="main-content">
          <Routes>
            <Route path="/" element={<SecuritiesFundLp />} />
            <Route path="/AppendixA" element={<AppendixA />} />
            <Route path="/TaxForms" element={<TaxForms />} />
            <Route path="/Success" element={<SuccessPage />} />
          </Routes>
        </div>

        <footer className="footer">
          Property of The Investments Lawyers, LLC &copy;
        </footer>
      </div>
    </Router>
  );
}

export default App;
